// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__3CYfH","footer":"ReportModalFilter_footer__hdXRM"};